import OcxBase from "./ocx-base";

export default class  extends OcxBase {
  constructor(params) {
    params = params || {};
    super(params);

    this.ocxId = "NTKO_OFFICE_" + $uuid();
    this.NTKO_SAVE_FORM = "NTKO_SAVE_FORM";
    this.events = {};

    //授权信息
    this.classid = params.classid;
    this.Caption = params.Caption;
    this.MakerCaption = params.MakerCaption;
    this.MakerKey = params.MakerKey;
    this.ProductCaption = params.ProductCaption;
    this.ProductKey = params.ProductKey;

    //相关url
    this.ocxPath = params.ocxPath;//控件下载路径
    this.uploadUrl = params.uploadUrl;//保存Url
    this.updateUrl = params.updateUrl;//保存Url
    this.downloadUrl = params.downloadUrl;//下载url
    this.pluginUrl = params.pluginUrl;//pdf 插件url

    this.fileName = params.fileName;
    this.fileType = params.fileType; //.doc,.docx
    this.fileId = params.fileId;
    this.efileType = params.efileType; //JOA_CLD,JOA_ZW
    this.userName = params.userName;
    this.fileLinkId = params.fileLinkId;
    this.pkId = params.pkId || params.businessId;

    this.tempBusinessId = params.tempBusinessId;
    this.formId = params.formId;
    this.businessId = params.businessId;
    this.xToken = params.xToken;

    this.setVersion = -1;
    this.PASS_WORD = "autosoft";

    var locationhref = window.location;
    var portStr = "";
    if (locationhref.port != 80) {
      portStr = ":" + locationhref.port;
    }
    this.httpPath = locationhref.protocol + "//" + locationhref.hostname + portStr;

    /**
     * 对齐方式
     * @enum {number}
     */
    this.AlignType = {//对齐方式
      "LEFT": 0,//居左
      "CENTER": 1,//居中
      "RIGHT": 2//居右
    };

    this.SaveMode = {
      NEW: "new",
      UPDATE: "update"
    }

    /**
     * 枚举所有的文档类型值用户保存用
     * @enum {number}
     */
    this.DocTypeValue = { //枚举所有的文档类型值用户保存用
      DOC: 0,
      DOCX: 16,
      XLS: 56,
      XLSX: 51
    };

    this.HttpMethod = {
      Get: 0, //Http对象get方式
      Post: 1 //Http对象post方式
    };

    /**
     * OFFICE或WPS 版本
     * @enum {number}
     */
    this.OfficeVersion = {//OFFICE或WPS 版本
      v2016: 2016,
      v2013: 2013,
      v2010: 2010,
      v2007: 2007,
      v2003: 2002,
      vOther: 0
    };

    /**
     * 枚举文档类型
     * @enum {number}
     */
    this.DocType = { // 枚举文档类型
      WORD: 0,//.doc,.docx,.wps
      EXECL: 1,//.xls,.xls,.et
      PPT: 2,//.ppt,.pptx
      PDF: 3,//.pdf
      TIF: 4//.tiff,.tif
    };

    /**
     * 保护模式
     * @enum {number}
     */
    this.ProtectMode = {//保护模式
      REVISIONS: 0, //仅允许在开启修订模式编辑
      POSTIL: 1, //仅允许在批注模式
      FORMFIELD: 2, //仅允许编辑窗体域
      READONLY: 3 //禁止编辑
    };

    /**
     * 对话框类型
     * @enum {number}
     */
    this.DialogType = {//对话框类型
      SAVEAS: 2
    }

    /**
     * 字号
     * @enum {number}
     */
    this.FontSize = {//字号
      "初号": 42,
      "小初": 36,
      "一号": 26,
      "小一": 24,
      "二号": 22,
      "小二": 18,
      "三号": 16,
      "小三": 15,
      "四号": 14,
      "小四": 12,
      "五号": 10.5,
      "小五": 9,
      "六号": 7.5,
      "小六": 6.5,
      "七号": 5.5,
      "八号": 5
    };
  }


  /**
   * @param ocx 控件对象
   */
  setOcx(ocx) {
    this.ocx = ocx;
  }


  /**
   * 创建一个表单
   * @param {object} data 数据
   */
  createForm(data) {
    var doc;
    if (this.el) {
      var win = this.el[0].contentWindow;
      doc = win.contentDocument || win.document
    }
    doc = doc || document;
    this.clearForm();
    var data = data || {};
    var fm = doc.getElementById(this.NTKO_SAVE_FORM);
    if (!fm) {
      fm = $("<form id='" + this.NTKO_SAVE_FORM + "' method='post'></form>");
    } else {
      fm = $(fm);
    }
    fm.children().remove();
    for (var k in data) {
      fm.append("<input type='hidden' name='" + k + "' value='" + data[k] + "' />");
    }
    $(doc.body).append(fm);
  }

  /**
   * 清除表单
   */
  clearForm() {
    var doc;
    if (this.el) {
      var win = this.el[0].contentWindow;
      doc = win.contentDocument || win.document
    }
    doc = doc || document;
    $(doc.body).find("#" + this.NTKO_SAVE_FORM).remove();
  }

  /**
   * 浏览器打印日志
   * @param {string} msg 日志内容
   */
  log(msg) {
    if (!this.__loginfo) {
      this.__loginfo = []
    }
    this.__loginfo.push(msg);
    // if (window.console && window.console.log) {
    //   window.console.log(msg);
    // }
  }

  /**
   * 异常日志
   * @param {string} msg 异常内容
   */
  error(msg) {
    this.log("ERROR====>" + msg);
    if (window.console && window.console.trace) {
      window.console.trace(msg);
    }
  }

  warn(msg) {
    if (window.console && window.console.warn) {
      window.console.warn(msg);
    }
  }

  /**
   * 获取文件类型(后缀名)
   * @param {string} fileName 文件名
   * @returns {string} 后缀名
   */
  getFileType(fileName) {
    fileName = fileName || this.fileName || "";
    if (fileName) {
      var arr = fileName.split(".");
      return "." + arr[arr.length - 1];
    } else if (this.ocx) {
      if (this.isWord()) {
        return ".doc"
      } else if (this.isExcel()) {
        return ".xls";
      } else if (this.isPPT()) {
        return ".ppt";
      }
    }
  }

  /**
   * 获取文件类型
   * @param  {string} fileType 文件类型(后缀名)
   * @returns {number}  查看 this.DocType
   */
  getDocType(fileType) {
    fileType = fileType || this.fileType;
    if (fileType) {
      if (fileType == ".doc" || fileType == ".docx" || fileType == ".wps") { // word
        return this.DocType.WORD;
      }
      if (fileType == ".xls" || fileType == ".xlsx" || fileType == ".et") { // execl
        return this.DocType.EXECL;
      }
      if (fileType == ".ppt" || fileType == ".pptx" || fileType == ".dps") {
        return this.DocType.PPT;
      }
      if (fileType == ".pdf") {
        return this.DocType.PDF;
      }
      if (fileType == ".tiff" || fileType == ".tif") {
        return this.DocType.TIF;
      }
    } else if (this.ocx) {
      if (this.ocx.DocType == 1 || this.ocx.DocType == 6) {
        return this.DocType.WORD;
      }
      if (this.ocx.DocType == 2) {
        return this.DocType.EXECL;
      }
      if (this.ocx.DocType == 3) {
        return this.DocType.PPT;
      }
      if (this.ocx.DocType == 51) {
        return this.DocType.PDF;
      }
    }
    return -1;
  }

  /**
   * 新建文档
   */
  createNew() {
    var docType = this.getDocType(this.fileType); // 获取文档类型
    switch (docType) {
      case this.DocType.WORD:
        this.ocx.CreateNew("Word.Document"); // 创建word
        break;
      case this.DocType.EXECL:
        this.ocx.CreateNew("Excel.Sheet"); // 创建execl
        break;
      default:
        this.ocx.CreateNew("Word.Document"); // 默认创建word文档
        break;
    }
  }


  /**
   * 解除保护
   */
  unProtect() {
    if (this.isWord()) {
      try {
        this.ocx.ActiveDocument.Unprotect(this.PASS_WORD);
      } catch (e) {
        this.error(e);
      }
    } else if (this.isExcel()) {
      var sheets = this.ocx.ActiveDocument.Sheets;
      for (var i = 1; i <= sheets.Count; i++) {
        try {
          sheets(i).Unprotect(this.PASS_WORD);
        } catch (e) {
          this.error(e);
        }
      }
    }
  }

  /**
   * 文档保护类型
   * @returns {number}    查看 {@link ProtectMode}
   */
  getProtectType() {
    return this.ocx.ActiveDocument.ProtectionType;
  }

  /**
   * 保护文档
   * @param {number} type 查看 {@link ProtectMode}
   * @param {boolean} noReset 不重置窗体域
   */
  protect(type, noReset) {
    if (this.isWord()) {
      var protectType = this.getProtectType();
      if (protectType != -1) {
        try {
          this.unProtect();
        } catch (e) {
          this.error(e);
        }
      }
      this.ocx.ActiveDocument.Protect(type, noReset || false, this.PASS_WORD);
    } else if (this.isExcel()) {
      var sheets = this.ocx.ActiveDocument.Sheets;
      for (var i = 1; i <= sheets.Count; i++) {
        try {
          sheets(i).Protect(this.PASS_WORD);
        } catch (e) {
          this.error(e);
        }
      }
    }

  }

  /**
   * 插入文字
   * @param {string} text 文本
   */
  addText(text) {
    this.ocx.ActiveDocument.Application.Selection.TypeText(text);
  }

  /**
   *定位到文档开始位置
   **/
  homeKey() {
    var me = this;
    me.ocx.ActiveDocument.Application.Selection.HomeKey(6);
  }

  /**
   * 定位到文档结束位置
   **/
  endKey() {
    var me = this;
    me.ocx.ActiveDocument.Application.Selection.EndKey(6);
  }

  /**
   *向上移动
   * @param {number} unit 移动的单位,默认"行" 值:5-行,4-节,
   * @param {number} count 移动的单位数，默认1
   **/
  moveUp(unit, count) {
    var me = this;
    if (!unit) unit = 5;
    if (!count) count = 1;
    me.ocx.ActiveDocument.Application.Selection.MoveUp(unit, count);
  }

  /**
   *向下移动
   * @param {number} unit 移动的单位,默认"行" 值:5-行,4-节,
   * @param {number} count 移动的单位数,默认1
   **/
  moveDown(unit, count) {
    var me = this;
    if (!unit) unit = 5;
    if (!count) count = 1;
    me.ocx.ActiveDocument.Application.Selection.MoveDown(unit, count);
  }

  /**
   *向左移动
   * @param {number} unit 移动的单位,默认"字符" 值:1-字符(wdCharacter)
   * @param {number} count 移动的单位数,默认1
   **/
  moveLeft(unit, count) {
    var me = this;
    if (!unit) unit = 1;
    if (!count) count = 1;
    me.ocx.ActiveDocument.Application.Selection.MoveLeft(unit, count);
  }

  /**
   *向右移动
   *@param {number} unit 移动的单位,默认"字符" 值:1-字符(wdCharacter)
   *@param {number} count 移动的单位数,默认1
   **/
  moveRight(unit, count) {
    var me = this;
    if (!unit) unit = 1;
    if (!count) count = 1;
    me.ocx.ActiveDocument.Application.Selection.MoveRight(unit, count);
  }

  /**
   * 换行
   */
  nextLine() {//下一行
    this.ocx.ActiveDocument.Application.Selection.TypeParagraph();
  }

  /**
   * 选中书签
   * @param {string} lblName 书签名
   */
  selectBookMark(lblName) {
    var bookmarks = this.ocx.ActiveDocument.Bookmarks;
    if (this.hasBookMark(lblName)) {
      bookmarks.Item(lblName).Range.Select();
    }
  }

  /**
   * 判断是否存在书签
   * @param {string} lblName
   * @returns {boolean} 是否存在
   */
  hasBookMark(lblName) {
    return this.ocx.ActiveDocument.BookMarks.Exists(lblName);
  }

  /**
   * 设置书签值
   * @param {string} lblName 书签名
   * @param {string} lblValue 书签值
   * @returns {boolean} 是否设置成功
   */
  setBookMarkValue(lblName, lblValue) {
    this.log(lblName + ":" + lblValue);
    lblValue = lblValue || "";
    if (this.hasBookMark(lblName)) {
      var bk = this.ocx.ActiveDocument.Bookmarks(lblName);
      var start = bk.Range.Start;
      var end = start + lblValue.length;
      bk.Range.Text = lblValue;
      this.addBookMark(lblName, start, end);
      this.moveRight();
      return true;
    }
    this.warn("BookMark '" + lblName + "' is not found!!")
    return false;
  }

  /**
   * 获取书签值
   * @param {string} lblName 书签名
   **/
  getBookMarkValue(lblName) {
    var me = this;
    if (me.hasBookMark(lblName)) {
      return this.ocx.ActiveDocument.Bookmarks(lblName).Range.Text
    } else {
      return "";
    }
  }

  /**
   * 获取所有书签名
   * @returns {Array}
   */
  getBookMarksName() {
    var me = this;
    var marks = [];
    var bookmarks = me.ocx.ActiveDocument.BookMarks;
    var count = bookmarks.Count;
    for (var i = 1; i <= count; i++) {
      marks.push(bookmarks.Item(i).Name);
    }
    return marks;
  }

  /**
   * 获取书签数量
   * @returns {number}
   */
  getBookMarkCount() {
    var me = this;
    return me.ocx.ActiveDocument.BookMarks.Count;
  }

  /**
   *设置书签值
   * @params {object} data 数据map
   **/
  setBookMarkValues(data) {
    var me = this;
    for (k in data) {
      me.setBookMarkValue(k, data[k]);
    }
  }

  /**
   * office版本
   * @returns {string}
   */
  getOfficeVer() {
    return this.ocx.ActiveDocument.Application.Version;
  }

  /**
   *
   * 获取office版本信息
   * @returns {number}  <a href="#OfficeVersion">参考OfficeVersion</a>
   */
  getOfficeVersion() {
    var getVersion = 0.0;
    try {
      if (this.setVersion == -1) {
        getVersion = parseFloat(this.getOfficeVer());
        this.setVersion = getVersion;
      } else {
        getVersion = this.setVersion;
      }
      if (getVersion == 11.0) {
        return this.OfficeVersion.v2003;
      } else if (getVersion == 12.0) {
        return this.OfficeVersion.v2007;
      } else if (getVersion == 14.0) {
        return this.OfficeVersion.v2010;
      } else if (getVersion == 15.0) {
        return this.OfficeVersion.v2013;
      } else if (getVersion > 15.0) {
        return this.OfficeVersion.v2016;
      } else {
        return this.OfficeVersion.vOther;
      }
    } catch (e) {
      return this.OfficeVersion.v2003;
    }
  }

  /**
   * 打印
   */
  printOut() {
    var me = this;
    me.ocx.PrintOut(true);
  }

  /**
   * 接受所有修订,将文档所有修改痕迹清除
   * */
  acceptAllRevisions() {
    var me = this;
    if (me.getProtectType() != "-1") {
      me.unProtect();
    }
    try {
      me.ocx.ActiveDocument.AcceptAllRevisions();
    } catch (e) {
      this.error("AcceptAllRevisions Failed!:" + e);
    }
  }

  /**
   * //对话框
   * @param {number} dialogType 查看 {@link #DialogType}
   */
  showDialog(dialogType) {
    this.ocx.ShowDialog(dialogType);
  }

  /**
   * 另存为
   */
  saveAs() {//另存为
    this.ocx.FileSaveAs = true;
    if (this.isWord()) {
      var pType = this.getProtectType();
      if (pType == this.ProtectMode.READONLY) {
        this.unProtect();
        this.showDialog(this.DialogType.SAVEAS);
        me.protect(this.ProtectMode.READONLY);
        return;
      }
    }
    this.showDialog(this.DialogType.SAVEAS);
  }

  /**
   * 对齐
   * @param {number} alginType  查看this.AlignType
   */
  align(alginType) {
    var me = this;
    me.ocx.ActiveDocument.application.selection.Range.ParagraphFormat.Alignment = alginType;
  }

  /**
   * 居左
   */
  alignLeft() {
    this.align(this.AlignType.LEFT);
  }

  /**
   * 居中
   */
  alignCenter() {
    this.align(this.AlignType.CENTER);
  }

  /**
   * 居右
   */
  alignRight() {
    this.align(this.AlignType.RIGHT);
  }

  /**
   * 在文档中插入一个书签
   * @param {string} lblName 书签名
   * @param {number} start 开始位置
   * @param {number} end  结束位置
   */
  addBookMark(lblName, start, end) {
    var me = this;
    try {
      if (typeof(start) == "number" && typeof(end) == "number") {
        me.ocx.ActiveDocument.Range(start, end).Select()
      } else {
        me.ocx.ActiveDocument.Application.Selection.Select();
      }
      me.ocx.ActiveDocument.Bookmarks.Add(lblName);
    } catch (e) {
      me.error(e);
      return false
    }
    return true;
  }

  /**
   * 设置显示修订形式
   * @param {number} mode mode=1 在批注框中显示修订;mode=2 以嵌入方式显示所有修订;mode=3 仅在批注框中显示修订和格式
   */
  setMarkupMode(mode) {
    var me = this;
    me.ocx.ActiveDocument.ActiveWindow.View.MarkupMode = mode;
  }

  /**
   *在光标位置插入表格
   *@param {number} rows 行数
   *@param {number} cols 列数
   *@param {array} witdh 每列宽度
   **/
  createTable(rows, cols, width) {
    var me = this;
    var range = me.ocx.ActiveDocument.Application.Selection.Range;
    var table = me.ocx.ActiveDocument.Tables.Add(range, rows, cols, 1, 0)
    this.table = table;
    if (width.length == cols) {
      for (var i = 1; i <= rows; i++) {
        for (var j = 1; j <= cols; j++) {
          table.Cell(i, j).Width = width[j - 1];
        }
      }
    }
    me.log("createTable->rows:" + rows + ",cols:" + cols);
    return table;
  }

  /**
   *选中单元格
   *@param {number} rowIndex 行
   *@param {number} colIndex 列
   **/
  selectCell(rowIndex, colIndex) {
    var me = this;
    if (!this.table) {
      me.log("selectCell->not found table");
      return;
    }
    try {
      this.cell = this.table.Cell(rowIndex, colIndex);
      this.cell.Range.Select();
    } catch (e) {
      this.error("selectCell" + e);
    }
  }

  /**
   *设置单元格值
   *@param {number} rowIndex 行
   *@param {number} colIndex 列
   *@param {string} value 值-文本
   **/
  setCellValue(value, rowIndex, colIndex) {
    var me = this;
    if (!this.table) {
      me.log("setCellValue->not found table");
      return;
    }
    if (!this.cell) {
      me.log("setCellValue->not found cell");
      return;
    }
    try {
      if (rowIndex && colIndex) {
        this.table.Cell(rowIndex, colIndex).Range.Text = value;
      } else {
        this.cell.Range.Text = value;
      }
    } catch (e) {
      me.error(e);
    }

  }

  /**
   * 插入动态表格(通过书签定位将一个单元格拆分成多个单元格的方式)
   * @param data {Array} 数据 []
   * @param sqName {string} 书签名(该书签必须在表格之中)
   * @param thead  {Array} 表头内容数组,可选  例:["姓名","单位"]
   * @param content{Array} 属性字段数组,属性对应data里面数据属性 例:["a",c"]
   */
  createTableInCell(data, sqName, thead, content) {
    var me = this;
    if (!sqName || !me.hasBookMark(sqName)) { //判断是否存在该书签
      me.log("Bookmark" + sqName + " is not exists!")
      return;
    }
    var bk = ntko.ActiveDocument.Bookmarks.Item(sqName); //获取书签
    var tables = bk.Range.Tables; //获取书签所在表格
    if (tables.Count > 0) {
      var table = tables.Item(1);
      me.table = table;
      if (bk.Range.Cells.Count > 0) { //判断书签是否处于单元格之中
        var cell = bk.Range.Cells.Item(1); //获取书签所在单元格
        var colIdx = cell.columnIndex; //获取单元格列位置
        var rowIdx = cell.rowIndex; //获取单元格行位置
        var rowCount = (data ? data.length : 0) + (thead ? thead.length : 0); //计算要创建的表格行列数
        var colCount = (thead || content).length;
        cell.Split(rowCount, colCount); //将单位格拆分为rowCount行,colCount列
        var idx = 0;
        for (var r = rowIdx; r <= rowIdx + (thead && thead.length > 0 ? data.length : data.length - 1); r++) {
          table.Rows.Item(r).Range.ParagraphFormat.Alignment = 1; //左右居中
          table.Rows.Item(r).Height = 25; //设置单元格高度
          if (r == rowIdx && thead && thead.length > 1) {
            table.Rows.Item(r).Range.Font.Bold = true;//粗体
            table.Cell(r, 1).Range.Text = thead[c - 1];
            for (var c = 1; c <= thead.length; c++) {
              table.Cell(r, c).VerticalAlignment = 1; //单元格内容垂直居中
              table.Cell(r, c).Range.Text = thead[c - 1];
            }
          } else {
            var d = data[idx];
            for (var c = 1; c <= content.length; c++) {
              table.Cell(r, c).VerticalAlignment = 1;
              table.Cell(r, c).Range.Text = d ? d[content[c - 1]] : "";
            }
            idx++;
          }
        }
      }
    }
  }

  /**
   * 开启/关闭 记录修订功能
   * @param bool {boolean} true开启,false关闭
   */
  trackRevisions(bool) {//记录修订
    this.ocx.ActiveDocument.TrackRevisions = bool;
  }

  /**
   * 修订状态是否开启
   * @returns {*}
   */
  isTrackRevisions() {
    return this.ocx.ActiveDocument.TrackRevisions;
  }

  /**
   *是否wps 或 word 类型
   * @returns {boolean}
   */
  isWord() {
    return this.getDocType() == this.DocType.WORD
  }


  /**
   * 是否 Excel 或 wps表格
   * @returns {boolean}
   */
  isExcel() {
    return this.getDocType() == this.DocType.EXECL;
  }


  /**
   * 是否ppt类型
   * @returns {boolean}
   */
  isPPT() {
    return this.getDocType == this.DocType.PPT;
  }

  /**
   * 是否office类型 word excel ppt
   * @return {boolean}
   */
  isOfficeFile() {
    return this.isWord() || this.isExcel() || this.isPPT();
  }

  /**
   * 显示修订
   * @param {boolean} bool true/false
   */
  showRevisions(bool) {//显示/隐藏修订
    var me = this;
    if (me.isWord()) {
      try {
        me.ocx.ActiveDocument.ShowRevisions = bool;
      } catch (e) {
        me.error(e);
      }
    }
  }

  isShowRevisions() {
    var me = this;
    if (me.isWord()) {
      try {
        return me.ocx.ActiveDocument.ShowRevisions
      } catch (e) {
        me.error(e);
      }
    }
  }

  /**
   * 是否已保存
   * @returns {boolean}
   */
  isSaved() {
    var me = this;
    // if (!me.ocx) return true;
    // if (!me.ocx.Activedocument) return true;
    return me.ocx.Activedocument.Saved;
  }

  /**
   * 设置文档是否已经保存
   * @param {boolean} isSaved  true/false
   **/
  setSaved(isSaved) {
    this.ocx.Activedocument.Saved = isSaved;
  }

  /**
   * 设置修订用户
   * @param {string} userName 用户名
   */
  setUserName(userName) {//设置修订用户
    userName = userName || this.userName || "";
    if (this.isWord()) {
      if (userName) {
        this.ocx.ActiveDocument.Application.UserName = userName;
      }
      if (this.getOfficeVersion() >= this.OfficeVersion.v2013) {
        try {
          this.ocx.ActiveDocument.Application.Options.UseLocalUserInfo = true;//2013以上的登录office账号时,设置成本地用户信息
        } catch (e) {
        }
      }
    }

  }

  /**
   * 设置打开的文件名
   * @param {string} fileName 文件名
   */
  setFileName(fileName) {
    this.log("set fileName : " + fileName);
    if (fileName) {
      this.fileName = fileName;
    }
  }

  /**
   * 生成随机文件名
   * @param {string} docType 后缀名(.doc/.png/...)
   * @returns {string} 随机文件名
   */
  randomFileName(docType) {
    return ("" + Math.random()).substr(2) + (docType || ".doc");
  }

  removeAutoSave() {
    var obj = window.onlineEditPanelObj;
    if (!obj) return;
    if (obj.ocx) {
      obj.ocx.RemoveCustomButtonOnMenu(9);
    }
    clearInterval(obj.intervalFnId);
    delete obj.intervalFnId
    delete window.onlineEditPanelObj;
  }

  autoSave() {
    var obj = window.onlineEditPanelObj;
    if (!obj || !obj.ocx) return;
    obj.countdown = obj.countdown - 1;
    if (obj.countdown > 0) {
      var minute = Math.floor(obj.countdown / 60);
      obj.ocx.AddCustomButtonOnMenu(9, "  " + (minute != 0 ? minute + "分" : "") + obj.countdown % 60 + "秒后自动保存");
    } else {
      clearInterval(obj.intervalFnId);
      obj.ocx.AddCustomButtonOnMenu(9, "  自动保存中.....");
      obj.saveDocumentToServer();
      obj.ocx.RemoveCustomButtonOnMenu(9);
      obj.countdown = obj.autoSaveInterval * 60;
      obj.intervalFnId = setInterval("autoSave()", 1000);
    }
  }

  setAutoSave() {
    var me = this;
    let re = 5;
    MW.mwApi.data.getDictByCode("自动保存间隔时长").then(function (v) {
      if (v && v.result && v.result.active == "T") {
        re = v.result.values ? v.result.values : 0;
        if (re && PF.isNumber((re = parseInt(re))) && re > 0) {
          me.autoSaveInterval = re;
          me.countdown = re * 60; //倒计时 秒
          window.onlineEditPanelObj = me;
          window.autoSave = me.autoSave;
          me.intervalFnId = setInterval("autoSave()", 1000);
        }
      }
    }).catch(err => console.log(err));
  }


  /**
   *
   * @param scope
   * @param exp
   * @returns {*}
   * @private
   */
  _eval(scope, exp) {
    function ExprEvaluator(scope, context) {
      this.scope = scope;
      this.context = context;
      this.evalFn = this.createScope();
    }

    ExprEvaluator.prototype = {
      variableRe: /^[_a-zA-Z][_0-9a-zA-Z]*$/,
      keywords: ["extends", "break", "case", "catch", "continue", "null", "debugger", "default", "delete", "do", "else", "finally", "for", "function", "if", "in", "instanceof", "new", "return", "switch", "this", "throw", "try", "typeof", "var", "void", "while", "with"],
      isValidVariable: function (name) {
        return this.variableRe.test(name) && this.keywords.indexOf(name) == -1;
      },
      createScope: function () {
        var body = '';
        var scope = this.scope;
        if (scope) {
          for (var key in scope) {
            //if(scope.hasOwnProperty(key) && this.isValidVariable(key)){
            if (scope.hasOwnProperty(key) && this.isValidVariable(key)) {
              body += "var " + key + " = __$$__." + key + ";";
            }
          }
        }
        body += "try{return eval(__$__)}catch(e){return ''}"
        return new Function("__$__", "__$$__", body);
      },
      eval: function (expr) {
        return this.evalFn.call(this.context, expr, this.scope);
      }
    }

    return new ExprEvaluator(scope).eval(exp);

  }

  /**
   *js表达式计算
   * @param scope {object}
   * @param exp {string}
   * @returns {*}
   */
  _eval_(scope, exp) {
    var variableRe = /^[_a-zA-Z][_0-9a-zA-Z]*$/;
    var keywords = ["extends", "break", "case", "catch", "continue", "null", "debugger", "default", "delete", "do", "else", "finally", "for", "function", "if", "in", "instanceof", "new", "return", "switch", "this", "throw", "try", "typeof", "var", "void", "while", "with"];

    function isValidVariable(name) {
      return variableRe.test(name) && keywords.indexOf(name) == -1;
    }

    var body = '';
    if (scope) {
      for (var key in scope) {
        if (scope.hasOwnProperty(key) && isValidVariable(key)) {
          body += "var " + key + " = __$$__." + key + ";";

        }
      }
    }
    body += exp;
    var func = new Function("__$$__", body);
    try {
      return func(scope, exp);
    } catch (e) {
      return '';
    }
  }


  /**
   * 设置页码
   * @param {string} fontName  页码字体
   * @param {number} fontSize 页码大小
   * @param {string} text 页码前后字符
   */
  setPageNumber(fontName, fontSize, text) {
    fontName = fontName || "宋体";
    fontSize = fontSize || 14.25;
    text = text || "－";
    var ActiveDocument = this.ocx.ActiveDocument;
    ActiveDocument.ActiveWindow.ActivePane.View.SeekView = 10;
    var Sections = ActiveDocument.Sections;//章节
    function setNumber(footer, align) {//设置页码
      footer.Range.Delete();//清空
      footer.PageNumbers.NumberStyle = 0;//默认样式
      var rng = footer.Range;
      rng.Text = text;
      rng.Collapse(1);
      ActiveDocument.Fields.Add(rng, 33, "Page");
      rng.Collapse(1);
      rng.Text = text;
      footer.Range.Font.Size = fontSize;
      footer.Range.Font.Name = fontName;
      footer.Range.ParagraphFormat.WordWrap = false
      footer.Range.ParagraphFormat.Alignment = align; //2-right,0-left
      footer.Range.ParagraphFormat.CharacterUnitRightIndent = 1;
      footer.Range.Fields.Update();
    }

    for (var i = 1; i <= Sections.Count; i++) {
      Sections.Item(i).PageSetup.DifferentFirstPageHeaderFooter = false;//首页不同
      Sections.Item(i).PageSetup.OddAndEvenPagesHeaderFooter = true;//奇偶页不同
      for (var ii = 1; ii <= 3; ii++) {//去掉页眉横线
        ActiveDocument.Sections(i).Headers(ii).Range.Paragraphs.Item(i).Format.Borders(-3).Color = 0;
        ActiveDocument.Sections(i).Headers(ii).Range.Paragraphs.Item(i).Format.Borders(-3).LineStyle = 0;
      }
      //设置页码
      var footer = ActiveDocument.Sections(i).Footers.Item(1);//奇数页 页脚
      setNumber(footer, this.AlignType.LEFT);//页码在左
      footer = ActiveDocument.Sections(i).Footers.Item(3);//偶数页 页脚
      setNumber(footer, this.AlignType.RIGHT);//页码在右
    }
    ActiveDocument.ActiveWindow.ActivePane.View.SeekView = 0;
  }

  /**
   * 厘米转像素点
   * @param {number} cm 长度(厘米)
   */
  cmToPoints(cm) {
    return this.ocx.ActiveDocument.Application.CentimetersToPoints(cm);
  }

  /**
   * 设置边距(单位厘米)
   * @param {number} top  上边距
   * @param {number} bottom 下边距
   * @param {number} left  左边距
   * @param {number} right  右边距
   */
  setPageMargin(top, bottom, left, right) {
    top = top || 3.7;
    bottom = bottom || 3.4;
    left = left || 2.8;
    right = right || 2.6;
    try {
      var ActiveDocument = this.ocx.ActiveDocument;
      ActiveDocument.PageSetup.TopMargin = this.cmToPoints(top);
      ActiveDocument.PageSetup.BottomMargin = this.cmToPoints(bottom); //页面下边距
      ActiveDocument.PageSetup.LeftMargin = this.cmToPoints(left); //页面左边距
      ActiveDocument.PageSetup.RightMargin = this.cmToPoints(right)//页面右边距
    } catch (e) {
      this.error(e);
    }
  }

  /**
   *
   * @param {string} fontName  正文字体
   * @param {number} fontSize  正文大小
   * @param {boolean} bold    是否加粗
   * @param {number} lineSpacingRule  单倍行距/多倍行距/固定值 this.LineSpacingRule
   * @param {number} lineSpacing  行间距 磅
   * @param {number} indent 首行缩进 字符
   */
  setParagraphFormat(fontName, fontSize, bold, lineSpacingRule, lineSpacing, indent) {
    fontName = fontName || "仿宋_GB2312";
    fontSize = fontSize || this.FontSize["四号"];
    bold = bold || false;
    lineSpacingRule = lineSpacingRule || this.LineSpacingRule.EXACTLY;
    lineSpacing = lineSpacing || 29;
    indent = indent || 2;
    var ActiveDocument = this.ocx.ActiveDocument;
    ActiveDocument.Application.Selection.Range.Font.Name = fontName;
    ActiveDocument.Application.Selection.Range.Font.Size = fontSize;
    ActiveDocument.Application.Selection.Range.Font.Bold = bold;
    ActiveDocument.Application.Selection.ParagraphFormat.LineSpacingRule = lineSpacingRule;
    ActiveDocument.Application.Selection.Range.ParagraphFormat.LineSpacing = lineSpacing; //行间距29磅
    ActiveDocument.Application.Selection.ParagraphFormat.CharacterUnitFirstLineIndent = indent;
  }

  /**
   * 设置样式
   * @param {string} styleName 样式名称
   * @param {string} nameFarEast 汉字字体
   * @param {number} fontSize 字体大小
   */
  setStyle(styleName, nameFarEast, fontSize) {
    var ActiveDocument = this.ocx.ActiveDocument;
    try {
      var stl = ActiveDocument.Styles.Item(styleName);
      if (stl) {
        stl.Font.Size = fontSize || this.FontSize["三号"];
        stl.Font.NameFarEast = nameFarEast;
      }
    }
    catch (e) {
      this.error(e);
    }
  }

  /**
   * 全文规范
   */
  standardizing() //全文规范
  {
    this.setPageMargin();
    this.setParagraphFormat();   // 1、默认编写文字字体仿宋_GB2312字体，三号// 2、首行空两个字符；// 3、行间距29磅；
    this.setPageNumber();       // 4、页码奇偶也不同，奇数页在右侧，页码格式“-1-”，为四号半角阿拉伯数字。
    this.setStyle("正文", "仿宋_GB2312");
    this.homeKey();
  }

  /**
   * 关闭文档
   */
  closeDocument() {
    this.removeAutoSave();
    if (this.ocx) {
      try {
        this.ocx.Close()
      } catch (e) {

      }
    }
  }

  getTpl() {

    var classid = this.classid || "clsid:01DFB4B4-0E07-4e3f-8B7A-98FD6BFF153F";
    var Caption = this.Caption || "欢迎使用WebOffice综合办公系统!";
    var MakerCaption = this.MakerCaption || "北京美络克思科技有限公司";
    var MakerKey = this.MakerKey || "C3F5BF43B534CDC8150F57D0647A14DB2F126CAC";
    var ProductCaption = this.ProductCaption || "美络科技OA系统";
    var ProductKey = this.ProductKey || "566C944216242DE373C29867DC8E7AA682C2CC45";
    var ocxPath = this.ocxPath;
    var ocxId = this.ocxId;
    var tpl = `<object style="z-index:-999999;" class="officeOcx" id="${ocxId}"
            classid="${classid}"
            codebase="${ocxPath}"
            width="100%" height="100%">
            <param name="BorderStyle" value="1">
            <param name="Titlebar" value="0">
            <param name="Menubar" value="-1">
            <param name="ToolBars" value="-1">
            <param name="IsShowHelpMenu" value="0">
            <param name="IsShowToolMenu" value="-1">
            <param name="Caption" value="${Caption}">
            <param name="MakerCaption" value="${MakerCaption}">
            <param name="MakerKey" value="${MakerKey}">
            <param name="ProductCaption" value="${ProductCaption}">
            <param name="ProductKey" value="${ProductKey}">
            <param name="FileNew" value="0">
            <param name="FileOpen" value="0">
            <param name="FileSave" value="0">
            <param name="FileClose" value="0">
            <param name="IsStrictNoCopy" value="0">
            <param name="IsRemoveMacrosOnSave" value="0">
            <param name="MaxUploadSize" value="0">
            <param name="FileSaveAs" value="0">
            <param name="IsNoCopy" value="0">
            <param name="IsUseUTF8URL" value="1">
            <param name="IsUseUTF8Data" value="1">
            <SPAN STYLE="color:red">不能装载文档控件,请在检查浏览器的选项中检查浏览器的安全设置。</SPAN>
          </object>`;
    return tpl;
  }


  /**
   *
   * @param {jQuery|HTMLElement} iframe
   */
  setIframe(iframe) {
    var me = this;
    if (!this.el) {
      this.el = iframe;
    }
    var win = iframe[0].contentWindow;
    var doc = win.contentDocument || win.document;
    var elements = doc.getElementsByTagName("object");
    $.each(elements, function (index, el) {
      var id = el.id || id;
      if (id.substring(0, 11) == "NTKO_OFFICE") {
        me.ocxId = id;
        me.setOcx(el);
        return true;
      }
    })
  }

  addEvent(eventName, handler) {
    var me = this;
    var doc;
    if (window.attachEvent && this.ocx) {//高版本IE不支持此属性
      this.ocx.attachEvent(eventName, handler);
      return;
    }
    if (this.el) {
      var win = this.el[0].contentWindow;
      doc = win.contentDocument || win.document
    }
    if (doc.getElementById(eventName)) return;
    doc = doc || document;
    var head = doc.head || doc.getElementsByTagName("head")[0] || doc.documentElement;
    var node = doc.createElement("script");
    node.charset = "UTF-8";
    node.setAttribute("language", "JScript");
    node.setAttribute("for", this.ocxId);
    node.setAttribute("event", eventName);
    node.setAttribute("id", eventName);
    var ocxId = this.ocxId;
    var scriptHtml = `
    var arg=arguments;
    var ocx=document.getElementById('${ocxId}');
    if(ocx&&document.createEvent){
      var evt = document.createEvent('HTMLEvents');
      evt.initEvent('_${eventName}_', false, false);
      evt._arg=arg;
      ocx.dispatchEvent(evt);
    }
    `
    node.innerHTML = scriptHtml;
    head.appendChild(node);

    this.ocx.addEventListener(`_${eventName}_`, function (evt) {
      if (handler) {
        handler.call(me, evt);
      }
    })
  }


  /**
   * 渲染
   * @param to  {string} jquery选择元素
   * @param scope {jQuery|HTMLElement} 元素限定范围范围
   * @returns {*|jQuery|HTMLElement}
   */
  render(to, scope) {
    this.renderTo = to || this.renderTo;
    this.scope = scope || this.scope;
    var me = this;
    var tpl = this.tpl || this.getTpl();
    var iframeHtml = '<iframe scrolling="false" name="NTKO_EDITOR"   style="height:700px;width:100%;border:none;padding:0;margin:0;left:0;top:0;z-index:-999999;overflow:hidden;background-color:#fff;" src="about:blank"></iframe>';

    var iframe = $(iframeHtml);
    iframe.on("load", function () {
      var win = iframe[0].contentWindow;
      var doc = win.contentDocument || win.document;
      // doc.write(tpl);
      doc.body.innerHTML = tpl;
      var ocx = doc.getElementById(me.ocxId);
      me.setOcx(ocx);
      setTimeout(function () {
        if (me.events.load) {
          me.events.load.call(me);
        }
      }, 100)
    });
    this.el = iframe;
    if (this.renderTo) {
      if (this.renderTo) {
        $(this.renderTo, scope).append(iframe)
      }
    }

    return iframe;

  }


  destroy() {
    this.closeDocument();
    this.ocx = null;
    if (this.el) {
      this.el.remove();
    }
    this.el = null;
  }

  /**
   * 重新渲染
   */
  rerender() {
    this.destroy();
    if (this.renderTo) {
      this.render(this.renderTo, this.scope);
    }
  }

  on(key, func) {
    this.events[key] = func;
  }


  formatDateStr(fmt, source) {
    //设置日期格式
    source = source + "";
    if (typeof(source) == "string") {
      source = new Date(Date.parse(source.replace(/-/g, "/")));
    }
    var o = {
      "M+": source.getMonth() + 1,
      //月份
      "d+": source.getDate(),
      //日
      "h+": source.getHours(),
      //小时
      "m+": source.getMinutes(),
      //分
      "s+": source.getSeconds(),
      //秒
      "q+": Math.floor((source.getMonth() + 3) / 3),
      //季度
      "S": source.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (source.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }

  getBaseName(fileName) {
    if (!fileName) return "";
    return fileName.substring(0, fileName.lastIndexOf("."));
  }

  getBoolValue(bool, defaultValue) {
    return typeof(bool) == "boolean" ? bool : (typeof(defaultValue) == "boolean" ? defaultValue : false);
  }


  /**
   *通过url打开服务器文件
   * @param url {string}
   */
  openFromUrl(url) {
    this.log(url);
    try {
      this.addDocTypePlugins();
    } catch (e) {
    }
    try {
      this.ocx.OpenFromURL(url, false);
    } catch (e) {
      return false;
    }
    return true;
  }

  /**
   * 添加插件
   */
  addDocTypePlugins() {
    var ver = this.pluginVersion || "4.0.0.8";
    var url = this.pluginUrl;
    this.ocx.AddDocTypePlugin(".pdf", "PDF.NtkoDocument", ver, url, 51, true);
    this.ocx.AddDocTypePlugin(".tif", "TIF.NtkoDocument", ver, url, 52);
    this.ocx.AddDocTypePlugin(".tiff", "TIF.NtkoDocument", ver, url, 52);
  }

  /**
   *
   * @param url {string}
   */
  addTempFromUrl(url) {
    // var url = this.downloadUrl + "?id=" + id;
    this.log("addTempFromURL : " + url)
    this.ocx.AddTemplateFromURL(url)
  }

  /**
   * 显示标题栏
   * @param {boolean} bool ture/false
   */
  showTitleBar(bool) {
    this.ocx.TitleBar = bool;
  }

  /**
   * 显示工具栏
   * @param {boolean} bool
   */
  showToolBars(bool) {
    this.ocx.ToolBars = bool;
  }

  setReadOnly(bool) {
    this.ocx.IsReadOnly = bool;
  }

  isReadOnly() {
    return this.ocx.IsReadOnly;
  }

  /**
   * 设置文件名
   * @param {string} fileName 文件名(另存为时用到)
   */
  setWebFileName(fileName) {
    this.ocx.WebFileName = this.FileName || fileName;
  }
}





// WEBPACK FOOTER //
// ./src/common/components/extend/ntko/src/ntko-func-base.js